import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PlayerLanguageModalTitle = styled.span<React.CSSProperties>`
  color: ${Colors['modal']['title']};
  font-family: ${Fonts['bold']};
  font-size: ${40 * Screen.widthRatio}px;
  margin-bottom: ${52 * Screen.widthRatio}px;
`;

export default PlayerLanguageModalTitle;
